import { render, staticRenderFns } from "./SetupVip.vue?vue&type=template&id=f02b386e&"
import script from "./SetupVip.vue?vue&type=script&lang=js&"
export * from "./SetupVip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports